<template>
  <c-selectable
    v-bind="$attrs"
    v-on="$listeners"
    @click.native.stop
  />
</template>

<script>
import CSelectable from '@convenia/components/CSelectable'

export default {
  name: 'MobileSelectable',
  components: { CSelectable },
}
</script>
